<template>
  <div>
      <stickyNav v-if="enableStickyNav" />
        <section class="blue-section section-shaped section-lg my-0">
            <div class="container pt-lg-md">
                <div class="text-center justify-content-center">
                    <h3 class="display-3 text-white">Pricing
                    </h3>
                    <p class="lead text-white px-5 mx-md-5">Look through our catalogue for our charges and rates for the different use cases/channels and reach out to us</p>
                </div>
            </div>
        </section>
        <section class="section bg-secondary pt-lg-5 px-lg-0 px-4">
            <div class="container pt-md-5 pt-0">
                <div class="text-center justify-content-center">
                    <div class="col-lg-12">
                        <h2 class="display-3 text-dark mb-5">Products</h2>
                    </div>
                </div>
                <div class="row my-4">
                    <div class="col-md-4 col-xs-12 mt-lg-0 mt-3">
                        <div class="card pricing-card text-center py-5 ">
                            <div class="card-body pricing-card-body px-5">
                                <h5 class="card-title">SUITE</h5>
                                <!-- <p class="users" style="font-size:13px">1 - 48 users</p> -->
                                <hr class="hr-primary">
                                <p style="font-size:14px" class="card-text pt-2 pb-4">
                                    Enjoy self-service<br>
                                    Recharge my line <br>
                                    Buy data <br> 
                                    Buy utility bills
                                </p>
                                <router-link to="/contact">
                                    <base-button type="info" class="mt-1">
                                    Contact Us
                                  </base-button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-xs-12 mt-lg-0 mt-3">
                        <div class="card pricing-card text-center py-5 ">
                            <div class="card-body pricing-card-body px-5">
                                <h5 class="card-title">ENTERPRISE</h5>
                                <!-- <p class="users" style="font-size:13px">1 - 48 users</p> -->
                                <hr class="hr-primary">
                                <p style="font-size:14px" class="card-text pt-2 pb-4">
                                    Partner with TopUpBox and its services. <br>Use all of its offers and services for your own business
                                </p>
                                <router-link to="/contact">
                                    <base-button type="info" class="mt-1">
                                    Contact Us
                                  </base-button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-xs-12 mt-lg-0 mt-3">
                        <div class="card pricing-card text-center py-5 ">
                            <div class="card-body pricing-card-body px-5">
                                <h5 class="card-title">MERCHANTS</h5>
                                <!-- <p class="users" style="font-size:13px">1 - 48 users</p> -->
                                <hr class="hr-primary">
                                <p style="font-size:14px" class="card-text pt-2 pb-4">
                                    Resell all of TopUpBox offers and services to my customers.<br>Become an agent in my environment
                                </p>
                                <router-link to="/contact">
                                    <base-button type="info" class="mt-1">
                                    Contact Us
                                  </base-button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="pt-5 px-lg-0 px-4">
            <div class="container">
                <h4 class="display-3 mb-5 text-dark">Commissions</h4>
                <table class="table telco-table text-center">
                    <thead class="table-light">
                        <tr>
                        <th scope="col">Telco</th>
                        <th scope="col">Rate</th>
                        <th scope="col">Deposit</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">MTN</th>
                            <td>30%</td>
                            <td>#5,000</td>
                        </tr>
                        <tr>
                            <th scope="row">GLO</th>
                            <td>30%</td>
                            <td>#5,000</td>
                        </tr>
                        <tr>
                            <th scope="row">AIRTEL</th>
                            <td>30%</td>
                            <td>#5,000</td>
                        </tr>
                        <tr>
                            <th scope="row">9MOBILE</th>
                            <td>30%</td>
                            <td>#5,000</td>
                        </tr>
                    </tbody>
                    </table>
            </div>
        </section>
  </div>
</template>

<script>
import StickyNav from '../layout/StickyHeader';
 
export default {
  name: "pricing",
  components: {
    StickyNav
  },
  data () {
    return {
      enableStickyNav: null,
    }
  },
  mounted() {
        // console.log('Index page created')
        // console.log('Sticky Nav mounted')
        window.addEventListener('scroll', this.handleNavDisplay)
    },
    // created() {},
    destroyed() {
        window.addEventListener('scroll', this.handleNavDisplay)
    },
    methods: {
        handleNavDisplay() {
        var y = window.scrollY
        if (y > 100 && !this.enableStickyNav) {
            // console.log ('Display New Menu')
            this.enableStickyNav = true
        } else if (y < 100 && this.enableStickyNav) {
            // console.log('Hide sticky Nav')
            this.enableStickyNav = false
        }
        }
    }
}
</script>

<style scoped>
.naira {
  font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
}
</style>